import { Seo, publicSiteOrigin } from "@/components/Seo";
import { LandingNav } from "@/components/landing/LandingNav";
import { Hero } from "@/components/landing/Hero";
import { TrustedBy } from "@/components/landing/TrustedBy";
import { Features } from "@/components/landing/Features";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { WhyPalNote } from "@/components/landing/WhyPalNote";
import { Testimonials } from "@/components/landing/Testimonials";
import { Pricing } from "@/components/landing/Pricing";
import { FAQSection } from "@/components/landing/FAQSection";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { LandingFooter } from "@/components/landing/LandingFooter";

const LANDING_TITLE =
  "PalNote — AI Medical Scribe & SOAP Note Generator for Rehab Clinics";
const LANDING_DESCRIPTION =
  "PalNote is the AI medical scribe for chiropractors, physiotherapists, and rehab clinics. Record patient visits and get accurate AI SOAP notes in seconds.";

function landingJsonLd(): Record<string, unknown>[] {
  const origin =
    publicSiteOrigin() + import.meta.env.BASE_URL.replace(/\/$/, "");
  return [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": `${origin}/#organization`,
      name: "PalNote",
      url: `${origin}/`,
      logo: `${origin}/logo.png`,
      description:
        "PalNote builds AI-powered clinical documentation software for chiropractors, physiotherapists, massage therapists, and MSK clinics.",
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": `${origin}/#website`,
      name: "PalNote",
      url: `${origin}/`,
      description: LANDING_DESCRIPTION,
      publisher: { "@id": `${origin}/#organization` },
      potentialAction: {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: `${origin}/faq?q={search_term_string}`,
        },
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "PalNote",
      url: `${origin}/`,
      image: `${origin}/opengraph.jpg`,
      applicationCategory: "MedicalApplication",
      operatingSystem: "Web",
      description: LANDING_DESCRIPTION,
      offers: [
        {
          "@type": "Offer",
          name: "Starter",
          price: "0",
          priceCurrency: "USD",
        },
        {
          "@type": "Offer",
          name: "Professional",
          price: "79",
          priceCurrency: "CAD",
        },
      ],
    },
  ];
}

export default function Landing() {
  return (
    <div className="min-h-screen bg-white text-slate-900 antialiased">
      <Seo
        title={LANDING_TITLE}
        description={LANDING_DESCRIPTION}
        path="/"
        jsonLd={landingJsonLd()}
      />
      <LandingNav />
      <main>
        <Hero />
        <TrustedBy />
        <Features />
        <HowItWorks />
        <WhyPalNote />
        <Testimonials />
        <Pricing />
        <FAQSection />
        <FinalCTA />
      </main>
      <LandingFooter />
    </div>
  );
}
